module.exports = __webpack_public_path__ + "img/succeed.c077d378.png";